import { createContext, useContext } from 'react';
import { PropertyDefinition } from 'inbound-db-properties-service-client/InboundDbPropertiesService-Unified/types';

type PropertyDefinitionOverride = {
  propertyDefinitionOverride?: PropertyDefinition;
};

export const PropertyDefinitionOverrideContext =
  createContext<PropertyDefinitionOverride>({});

export const PropertyDefinitionOverrideProvider =
  PropertyDefinitionOverrideContext.Provider;

export const usePropertyDefinitionOverride = () => {
  const { propertyDefinitionOverride } = useContext(
    PropertyDefinitionOverrideContext
  );
  return propertyDefinitionOverride;
};
